<template>
  <div>
    <div class="page">
      <b-row class="not-print">
        <b-col class="d-flex">
          <b-btn
            class="mr-3"
            @click="setLayout('thermal')"
            :variant="layout == 'thermal' ? 'primary' : 'outline-primary'"
            size="sm"
            pill
            >Impressão Térmica</b-btn
          >
          <b-btn
            @click="setLayout('common')"
            :variant="layout == 'common' ? 'primary' : 'outline-primary'"
            size="sm"
            pill
            >Impressão Comum</b-btn
          >
          <button class="btn btn-primary ml-auto" @click="print">
            Imprimir
          </button>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <component :is="layout" :bill_data="bill_data" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
 


<script>
import thermal from "@/components/billReceiveble/sections/BillReceivablePartialThermalPrint.vue";
import common from "@/components/billReceiveble/sections/BillReceivablePartialCommonPrint.vue";
export default {
  components: {
    thermal,
    common,
  },
  data: function () {
    return {
      layout: "common",
      products: {},
      bill_data: { bill: { person: {} }, products: [] },
      order: {},
      billPayment: {
        bill: { person: {} },
      },
    };
  },

  mounted() {
    this.$store.commit("pageHasLoaded");
  },
  computed: {
    company() {
      return this.$store.state.company;
    },
    print_layout() {
      return this.$store.getters["print/getPrintLayout"];
    },
  },

  created() {
    if (this.$route.params.id) {
      axios
        .post(process.env.BASE_URL + "api/billpayment/selectBillPayment", {
          id: this.$route.params.id,
        })
        .then((response) => {
          this.bill_data = response.data;
          this.billPayment = response.data;
          if (this.billPayment.bill.order_id) {
            this.getOrder();
          }
          this.layout = this.print_layout;
        })
        .catch((error) => {
          this.error = error;
        });
    }
  },

  methods: {
    print() {
      window.print();
    },
    setLayout(layout) {
      this.layout = layout;
      this.$store.dispatch("print/setPrintLayout", layout);
    },
    getOrder() {
      axios
        .post(
          process.env.BASE_URL +
            "api/order/edit/" +
            this.billPayment.bill.order_id
        )
        .then((response) => {
          this.bill_data.products = response.data.orderProducts;
          this.order = response.data.order;
        })
        .catch((error) => {});
    },
  },
};
</script>

<style   scoped>
.page {
  margin: 10px;
}
@media print {
  .not-print {
    display: none;
  }
}
</style>